<p class="bold">Create category</p>

<form class="mt-3 mb-3" [formGroup]="innerForm" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-md-12">
      <app-input
        [fc]="innerForm.get('category_id')"
        [label]="'Id (filled = edit / empty = new)'">
      </app-input>
    </div>
    <div class="col-md-12">
      <app-input
        [fc]="innerForm.get('category_title')"
        [label]="'title' | t">
      </app-input>
    </div>
    <div class="col-md-12">
      <app-select
        class="mb-3"
        [fc]="innerForm.get('category_parent_id')"
        [options]="categoryOptions"
        [emptyOption]="false"
        [label]="'Parent Category'">
      </app-select>
    </div>
  </div>

  <app-button
    [disabled]="innerForm.invalid"
    [submit]="true"
  >
    {{innerForm.get('category_id')?.value ? 'Update' : 'Create'}}
  </app-button>
</form>
